import React, { Fragment } from 'react';
import { node } from 'prop-types';
import classnames from 'classnames';
import Card from './card';

const Widget = ({
  title,
  subtitle,
  children,
  className,
  ...props
}) => (
  <Card
    className={classnames(
      'widgets-card',
      className,
    )}
    title={(
      <Fragment>
        <span className="widgets-card__title">{title}</span>
        <span className="widgets-card__subtitle">
          {subtitle}
        </span>
      </Fragment>
    )}
    {...props}
  >
    <div className="widgets-card__content">
      {children}
    </div>
  </Card>
);

Widget.propTypes = {
  children: node,
  title: node,
  subtitle: node,
};

Widget.defaultProps = {
  children: undefined,
  title: undefined,
  subtitle: undefined,
};

export default Widget;
